<div class="container-fluid p-5" data-testid="settings-container">
  <h4 class="font-weight-bold label-gray">Notification Throttling</h4>
  <div class="container-fluid mt-4">
    <p>
      <strong class="label-gray">Global Throttling Settings</strong> <br />
      Set a default throttling rate that applies to each individual message, <strong>unless overwritten at the message level</strong>.
    </p>
    <div class="throttle-option">
      <div class="d-flex align-items-center">
        <app-circle-radio-btn
          name="throttle-setting"
          [value]="true"
          [modelValue]="throttleEnabled"
          (modelValueChange)="handleThrottleToggle($event)"
          [dataTestId]="'throttle-radio-btn'"
        >
          <span>Throttle individual notifications at this hourly rate UNLESS overwritten at message level:</span>
        </app-circle-radio-btn>
        <div class="range-wrapper">
          <app-slider-range-input
            data-testid="slider"
            [min]="2500"
            [max]="50000"
            [step]="500"
            [value]="throttleRate"
            (valueChange)="onSliderChange($event)"
            [disabled]="!throttleEnabled"
          ></app-slider-range-input>
        </div>
      </div>
      <app-circle-radio-btn
        [name]="'throttle-setting'"
        [value]="false"
        [modelValue]="throttleEnabled"
        [disabled]="false"
        (modelValueChange)="handleThrottleToggle($event)"
        [dataTestId]="'no-throttle-radio-btn'"
      >
      <span>No default throttling rate. <span style="font-weight: normal;">Messages will not be throttled unless configured at
          the individual message level.</span> </span>
    </app-circle-radio-btn>
      <div class="mt-3">
        <button
          class="btn btn-primary save-btn"
          data-testid="save-btn"
          (click)="onSave()"
          >
          Save
        </button>
      </div>
    </div>

    <p class="mt-4 mb-0">
      <strong class="label-gray">Throttling in Progress</strong> <br />
    </p>

    <div class="d-flex flex-row-reverse align-items-center">
      <button
        id="refresh-throttling-info"
        class="btn btn-primary refresh-btn"
        (click)="onRefresh()"
        data-testid="refresh-throttling-info"
        >
        <span class="btn-label" i18n="Label for refresh-throttling-info button"
          >Refresh</span
          >
          <span class="icon icon-right">
            <i class="fa-solid fa-arrows-rotate" aria-hidden="true"></i>
          </span>
        </button>
        <p class="mt-4 mr-3 font-italic fw-normal last-updated">
          Last Updated {{ lastUpdatedDateStr }}
        </p>
      </div>
      <div class="mt-4">
        <!-- Header Row -->
        <div class="row fw-bold border-bottom pb-2 mb-2 header">
          <div class="col" (click)="onColumnHeadingClick('message')">
            Message
            <app-column-sort-icon
              id="sort-icon-message"
              [ordering]="ordering"
              [fieldName]="'message'"
            ></app-column-sort-icon>
          </div>
          <div class="col" (click)="onColumnHeadingClick('experience')">
            Experience
            <app-column-sort-icon
              id="sort-icon-experience"
              [ordering]="ordering"
              [fieldName]="'experience'"
            ></app-column-sort-icon>
          </div>
          <div class="col-5 text-center">Progress</div>
          <div class="col" (click)="onColumnHeadingClick('throttle_rate')">
            Throttle Rate
            <app-column-sort-icon
              id="sort-icon-throttle-rate"
              [ordering]="ordering"
              [fieldName]="'throttle_rate'"
            ></app-column-sort-icon>
          </div>
          <div class="col">Edit</div>
        </div>

        <!-- Data Rows -->
        <div
          class="selector-area"
          debounce
          data-infinite-scroll
          infiniteScroll
          [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle"
          (scrolled)="onScrollDown()"
          >
          @if (isLoadingMetrics &&
          experienceNotificationThrottlingMetrics.length === 0
          ) {
            <app-spinner></app-spinner>
          }
          @if (experienceNotificationThrottlingMetrics.length > 0) {
          @for (
          metric of experienceNotificationThrottlingMetrics; track
          metric; let i = $index) {
              <div
                class="row align-items-center py-2 border-bottom"
                >
                <div class="col">
                  {{ formatName(metric.componentNickname) }}
                </div>
                <div class="col">
                  {{ formatName(metric.experienceName) }}
                </div>
                <div class="col-5">
                  <app-bar-chart [metrics]="metric" [id]="i"></app-bar-chart>
                </div>
                <div class="col">
                  {{ formatMaxRate(metric.throttlingSettings) }}
                </div>
                <div class="col">
                  <button
                    class="btn edit-btn p-0"
                    (click)="onEditMetric(metric)"
                    data-testid="edit-btn-{{ i }}"
                    >
                    <i class="fa-solid fa-pencil" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            }
            @if (isLoadingMetrics) {
              <div class="d-flex justify-content-center py-3">
              <app-spinner></app-spinner>
            </div>
            }
          }
        </div>

        @if (
          !isLoadingMetrics &&
          experienceNotificationThrottlingMetrics.length == 0 &&
          !isFailedToLoadMetrics
          ) {
          <div
            class="not-found"
            i18n="
              Message that there were no experience notification throttling metrics
              found
            "
            >
        There were no experience notification throttling metrics found.
      </div>
        }
        @if (
          !isLoadingMetrics &&
          experienceNotificationThrottlingMetrics.length == 0 &&
          isFailedToLoadMetrics
          ) {
          <div
            class="not-found"
        i18n="
          Message that there was an error isLoadingMetrics experience
          notification throttling metrics
        "
            >
        Oops...Could not load experience notification throttling metrics.
      </div>
        }
      </div>
    </div>
    <message-dialog
      #messageDialog
      [showCancel]="false"
      [showAffirm]="false"
      [showClose]="true"
      >
    </message-dialog>
  </div>
